module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js
// module id = 1459
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21